import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const TransitionButton = ({
    isLocked,
    isOpenTransitionSection,
    openTransitionSection,
    allActions,
    entering,
}) => {
    return (
        <OverlayTrigger
            placement='top'
            onEntering={entering}
            overlay={
                <Tooltip
                    id='tooltip'
                    style={{
                        backgroundColor: 'rgb(0, 35, 58)',
                        color: 'white',
                        marginBottom: '20px',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: 'rgb(0, 35, 58)',
                            color: 'white',
                        }}
                    >
                        Transition
                    </div>
                </Tooltip>
            }
        >
            <div
                className={
                    isOpenTransitionSection
                        ? 'icon_fun outer-col active'
                        : 'icon_fun outer-col'
                }
                style={{
                    display: 'inline-block',
                }}
                onClick={isLocked === true ? null : openTransitionSection}
            >
                <span
                    className={isOpenTransitionSection ? 'active' : null}
                    style={{
                        cursor: isLocked === true ? 'not-allowed' : 'pointer',
                    }}
                >
                    <i
                        className={
                            allActions.hasOwnProperty('transition') &&
                            allActions.transition.icon !== null
                                ? allActions.transition.icon
                                : 'fa-regular fa-arrow-right-arrow-left'
                        }
                        style={{
                            color:
                                allActions.hasOwnProperty('transition') &&
                                allActions.transition.color !== null
                                    ? {
                                          color: allActions.show_pdf.color,
                                      }
                                    : {},
                        }}
                    />
                </span>
            </div>
        </OverlayTrigger>
    );
};

export default TransitionButton;
